import { FC } from 'react'

import { IconButton, QuickBuy, useSupportsHover } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../../../app/_providers/TranslationProvider.client'
import { trackEvent } from '../../../../../../../../../lib/analytics'

import { Body } from './styles'
import { useQuickBuyOverlayController } from './useQuickBuyOverlayController'

import type { IProps } from './IProps'

/**
 * @deprecate Use QuickBuyDialog from app directory.
 */
export const QuickBuyOverlay: FC<IProps> = ({
  embroideryConfig,
  activeProductFinalSale,
  analyticsContext,
  category,
  coloredVariants,
  ctaOnly = false,
  fitKeys,
  isCurrentColorCompletelySoldOut,
  isFavorites,
  onAddToCart,
  openQuickBuyModal,
  preferences,
  selectedFitKey,
  setSelectedFitKey,
  sizes,
  useLargeWidthSizeSelectorItems,
  rawCategory,
}) => {
  const supportsHover = useSupportsHover()
  const translations = useTranslation()

  const { height, steps } = useQuickBuyOverlayController({
    activeProductFinalSale,
    category,
    coloredVariants,
    ctaOnly,
    fitKeys,
    embroideryConfig,
    onAddToCart,
    openQuickBuyModal,
    preferences,
    selectedFitKey,
    setSelectedFitKey,
    sizes,
    supportsHover,
    rawCategory,
  })

  if (isCurrentColorCompletelySoldOut) return null
  return (
    <Body
      $isFavorites={isFavorites}
      $ctaOnly={ctaOnly}
      $heightPixels={height}
      $hideOnDesktop={isCurrentColorCompletelySoldOut}
      $useLargeWidthSizeSelectorItems={useLargeWidthSizeSelectorItems}
    >
      <IconButton
        type='button'
        variant='black-on-white'
        size='small'
        aria-label={translations.quickBuy.modal.headline}
        onClick={steps.initial.onSelect}
        ref={steps.initial.ref}
        style={{ padding: '0px' }}
        {...trackEvent({
          action: 'click',
          category: `${analyticsContext.category} quick buy`,
          label: 'quick-buy',
        })}
      >
        <QuickBuy width='30px' height='30px' />
      </IconButton>
    </Body>
  )
}
